import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scrollToTop";
import FormattedText from "./formattedText";
import { DEFAULT_HERO_IMG } from "../data/devotionals";

const IndividualDevotional = ({
  title,
  fullEntry,
  introScripture,
  scripturalReferences,
  coverImage,
}) => {
  return (
    <div className="individual-devotional-container">
      <div className="hero">
        <img src={coverImage || DEFAULT_HERO_IMG} alt="" />
        <h1>{title}</h1>
      </div>
      <div className="intro">
        <strong>
          <FormattedText text={introScripture} />
        </strong>
      </div>
      <div className="text">
        <FormattedText text={fullEntry} />
      </div>
      {scripturalReferences && (
        <div className="scriptures">
          <h3>Scriptural References:</h3>
          <FormattedText text={scripturalReferences} />
        </div>
      )}
      <div className="back">
        <Link to="/exegesis" onClick={scrollToTop}>
          <button>Back to all entries</button>
        </Link>
      </div>
    </div>
  );
};

export default IndividualDevotional;